import moment from 'moment';
import { Periodo } from 'shared/models/Periodo';
import { SelectOption } from '../models/SelectOption';

const dateGenerator = (dateList?: moment.Moment[]) => {
  if (!dateList) {
    dateList = [];
    dateList.push(moment().subtract(1, 'month'));
  }
  if (dateList.length === 12) {
    return dateList;
  } else {
    const temp = dateList[dateList.length - 1].clone();
    dateList.push(temp.subtract(1, 'month'));
    return dateGenerator(dateList);
  }
};

/**
 * @returns Lista con periodos correspondiente al ultimo año calendario
 */
export const generatePeriods = (): SelectOption<Periodo>[] => {
  const list = dateGenerator();
  let result = [];
  list.forEach((e) => {
    result.push({
      value: Periodo.fromMoment(e),
      label: e.format('MM/YYYY'),
    });
  });
  result.unshift({
    value: Periodo.getPeriodoActual(),
    label: 'Periodo Actual',
  });
  return result;
};
